import { ButtonHTMLAttributes, ReactNode } from 'react'

export default function PrimaryButton({ children, className, type, ...additionalProps }: {
	children: ReactNode,
} & ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
	return (
		<button type={type} {...additionalProps} className={`${className ?? ''} py-2 bg-gradient-to-b from-green-400 via-green-500 to-green-500 text-white rounded-full uppercase text-base font-extrabold shadow-md leading-5 md:h-11 md:text-lg hover:shadow-none hover:from-green-600 hover:via-green-500 hover:to-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-400 disabled:opacity-50 disabled:bg-none disabled:bg-gray-500 disabled:shadow-none disabled:hover:shadow-none`}>{children}</button>
	)
}
